import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import ResetContainer from './components/presentational/ResetContainer';
import useScript from '../../shared/hooks/useScript';
import BackgroundSlidesPageContainer from '../login/components/shared/BackgroundSlidesPageContainer';
import PageWrapper from '../login/components/shared/PageWrapper';
import useBackgroundSlides, { createLoginSlides } from '../login/components/hooks/useBackgroundSlides';

const slides = createLoginSlides(12);

const ResetPassword = () => {
  const location = useLocation();
  const isSetPassword = location.pathname === '/set-password';
  const { imageTransition } = useBackgroundSlides(slides);

  useScript('https://cdn.ywxi.net/js/1.js');

  return (
    <BackgroundSlidesPageContainer imageTransition={imageTransition}>
      <Helmet>
        <title>
          {isSetPassword ? 'Set Password' : 'Reset Password'}
          {' | Teambuildr'}
        </title>
      </Helmet>
      <PageWrapper>
        <ResetContainer isSetPassword={isSetPassword} />
      </PageWrapper>
    </BackgroundSlidesPageContainer>
  );
};

export default ResetPassword;
